import {createSlice} from '@reduxjs/toolkit'

const initialState = {
    stringFilter: {}, // {[listID]: "stringFilter"}
    advancedFilter: {}, // {[listID]: [advancedFilter]}
    setFilter: {}, // {[listID]: [advancedFilter]}
    listData: {}, // {[listID]: {listData}}
    checkedData: {}, // {[listID]: {listData}}
    preferences: JSON.parse(sessionStorage.getItem('list-preferences') || "{}"), // {[listID]: {columns: []}}
    prevListState: {}
}

export const enqueryListSlice = createSlice({
    name: 'enqueryListSlice',
    initialState,
    reducers: {
        setAdvancedFilter: (state, action) => {
            state.advancedFilter = {
                ...state.advancedFilter,
                [action.payload.id]: action.payload.filter
            };
        },
        setStringFilter: (state, action) => {

        },
        setListData: (state, action) => {

        },
        setCheckedData: (state, action) => {
            state.checkedData = {
                ...state.checkedData,
                [action.payload.id]: action.payload.data
            }
        },
        listUncheckAll: (state, action) => {
            state.checkedData = {
                ...state.checkedData,
                [action.payload]: []
            }
        },
        onChangeColumnsPreferences: (state, action) => {
            //payload schema  {listId, value}
            const {payload} = action;

            const currentPreferences = state.preferences[payload.listId] ? state.preferences[payload.listId].columns : [];

            //single selection
            if (!Array.isArray(payload.value)) {
                const inStorageIndex = currentPreferences.findIndex(i => i.name === payload.value.name);
                if (inStorageIndex !== -1) {
                    state.preferences[payload.listId].columns[inStorageIndex] = payload.value;
                    sessionStorage.setItem('list-preferences', JSON.stringify(state.preferences))
                    return;
                }
                if (!state.preferences[payload.listId]) {
                    state.preferences[payload.listId] = {columns: [payload.value]}
                    sessionStorage.setItem('list-preferences', JSON.stringify(state.preferences))
                    return;
                }
                state.preferences[payload.listId].columns.push(payload.value)
                sessionStorage.setItem('list-preferences', JSON.stringify(state.preferences))
            } else {
                state.preferences = {
                    ...state.preferences,
                    [payload.listId]: {
                        'columns': payload.value
                    }
                };
                sessionStorage.setItem('list-preferences', JSON.stringify(state.preferences))
            }
        },
        setPrevListState: (state, action) => {
            const {payload} = action;

            if(!payload) return;
            sessionStorage.setItem("listsState", JSON.stringify({
                ...JSON.parse(sessionStorage.getItem("listsState")) || {},
                ...payload,
            }))
            state.prevListState = {
                ...state.prevListState,
                ...payload
            }
        }
    }
})

export const {
    setListData,
    setAdvancedFilter,
    setStringFilter,
    setCheckedData,
    listUncheckAll,
    onChangeColumnsPreferences,
    setPrevListState
} = enqueryListSlice.actions;

export default enqueryListSlice.reducer;